"use strict";
exports.__esModule = true;
exports.chart_donut_pie_Height = {
  "name": "--pf-chart-donut--pie--Height",
  "value": 230,
  "var": "var(--pf-chart-donut--pie--Height, 230)"
};
exports["default"] = exports.chart_donut_pie_Height;